import axios from 'axios'

let SERVER_BASE_URL = ''

import global_ from '../global/index'
import { MessageBox } from 'element-ui'
import router from '../router'
import { Loading } from 'element-ui'

if (process.env.NODE_ENV == 'production') {
  if (window.location.host == 'xue2.eoffcn.com') {
    SERVER_BASE_URL = global_.global.online_url2
  } else {
    SERVER_BASE_URL = global_.global.online_url
  }
} else if (process.env.NODE_ENV == 'testing') {
  SERVER_BASE_URL = global_.global.test_url
} else {
  SERVER_BASE_URL = global_.global.local_url
}

let token = null
let loadingInstance = ''
axios.default.withCredentials = true
export default function fetch(options) {
  //token = 'test'
  return new Promise((resolve, reject) => {
    sso.ready().then(function (user) {//涉及登陆的页面代码必须放在ready的回调中
      const instance = axios.create({
        baseURL: SERVER_BASE_URL,
        method: options.method,
        // withCredentials: true,
        headers: user.getHeader(),
        transformResponse: [function (data) {
        }]
      })

      // 获取URL参数
      function getQueryString(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
        var r = window.location.hash.substr(window.location.hash.indexOf('?')).substr(1).match(reg)
        if (r != null) return decodeURI(r[2])
        return null
      }

      instance.interceptors.request.use(
        config => {
          loadingInstance = Loading.service({
            fullscreen: true, text: '加载中', background: 'rgba(0,0,0,0.5)'
          })
          if (options.type == 2) {
            config.headers['Content-Type'] = 'multipart/form-data'
          } else {
            config.headers['Content-Type'] = 'application/json;charset=utf-8'
          }
          if (getQueryString('ticket')) {
            config.headers['x-eoffcn-sso-gateway-token'] = getQueryString('ticket')
          }

          return config
        },
        err => {
          return Promise.reject(err)
        })

      instance.interceptors.response.use(
        response => {

          loadingInstance.close()
          let res = response.request.response
          res = JSON.parse(res)
          if (res.retcode !== 0) {
            if (res.retcode == 1002) {
              var url = window.location.href
              window.location.href = res.url + '&ref=' + encodeURIComponent(url)
            }
            if (res.retcode == 100081) {
              setTimeout(function () {
                document.querySelectorAll('.el-message.el-message--error')[0].style.display = 'none'
              }, 10)
              MessageBox({
                title: '操作失败',
                message: '您已打开多个店铺，只能在最后打开的店铺中进行操作，即将带您进入最后打开的店铺',
                confirmButtonText: '好的',
                showClose: false,
                dangerouslyUseHTMLString: true,
                closeOnClickModal: false,
                customClass: 'conflictShop',
                type: 'error'
              }).then(() => {
                if (window.location.href == window.location.origin + '/#/index') {
                  router.go(0)
                } else {
                  window.location.href = window.location.origin + '/#/index'
                }

              }).catch(() => {

              })
            }
            if (res.retcode == 100082) {
              // 店铺登录失败
              window.location.href = window.location.origin
            }
          }
          // return Promise.resolve(response);
          return res
        },
        error => {
          console.log('网络不给力，请稍后重试')
          loadingInstance.close()
          return Promise.reject(error) // 返回接口返回的错误信息
        })

      // 请求处理
      instance(options)
        .then((res) => {
          resolve(res)
          return false
        })
        .catch((error) => {
          reject(error)
        })
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js